import { service } from 'services';
import { hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

export default {
  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.TEMPLATE.GET_ALL,
    apiResult: service.template.getAll(),
    payloadKey: 'templates',
    isRetrieveItems: true,
  }),
};
